import React, { Component } from "react";
import { reduxForm } from "redux-form";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import CroField from "../generalForm/CroField";
import CroHtmlEditor from "../generalForm/CroHtmlEditor";
import CroSubhead from "../generalForm/CroSubhead";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import * as V from "../../../../utils/formValidation";

import { getFunctionaryNoticeTypes } from "../../CroActions";

class AppealOfficialForm extends Component {
  state = {
    noticeTypes: [],
  };

  async componentWillMount() {
    const noticeTypes = await getFunctionaryNoticeTypes(this.props.dispatch);
    this.props.breadcrumbs(this.props.breadcrumbsItems);
    this.props.change("appealType", noticeTypes.items.find((type) => type.id === this.props.initialValues.noticeTypeId)?.name || "");
    this.setState({ noticeTypes: noticeTypes.items });
  }

  render() {
    const {
      onSubmit,
      handleSubmit,
      submitting,
      templateKeysHelp,
    } = this.props;

    const { officialsIds } = this.props.initialValues;

    return (this.state.noticeTypes.length === 0 ? null : 
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label appealOfficialForm"
      >
        {officialsIds && officialsIds.length > 1 && <CroSubhead title={`Hromadná výzva ${officialsIds.length} veřejným funkcionářům`} />}
        <div className="appealOfficialForm__section">
            <CroField
              title="Typ výzvy"
              name="appealType"
              disabled
              component={Input}
              fullWidth
            />

          <div className="appealOfficialForm__contentWrapper">
            <CroField
              title="Předmět emailu"
              name="subject"
              component={Input}
              fullWidth
              validate={[V.required]}
              disabled={submitting}
            />
          </div>

          <div className="appealOfficialForm__contentWrapper">
            <CroHtmlEditor
              title="Obsah emailu"
              name="content"
              fullWidth
              rows={20}
              validate={[V.required]}
              disabled={submitting}
            />    
          </div>
        </div>

        {templateKeysHelp && templateKeysHelp.length > 0 && (
          <div className="appealOfficialForm__placeholders">
            <div className="placeholdersHint">V obsahu emailu můžete využít placeholdery, které se při odesílání nahradí konkrétními hodnotami. K dispozici jsou placeholdery:</div>
            <ul>
              {templateKeysHelp.map((key) => (
                <li key={key.name}><b>{key.name}</b> = {key.description}</li>
              ))}
            </ul>
          </div>
        )}

        <div className="appealOfficialForm__actions">
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            disabled={submitting}
            onClick={() => this.props.router.goBack()}
          />
          <Button
            type="button"
            style={styles.buttons}
            label="Odeslat"
            disabled={submitting}
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "appealOfficialForm",
})(asyncForm(AppealOfficialForm));
